<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button class="btnback btn btn-outline-success" type="button" (click)="onBack()" title="Volver"><i class="fa fa-chevron-left" (click)="onBack()"></i></button>
        <button *ngIf="!visibilitySpinner" type="button" class="btn btn-outline-success" [disabled]="formInvalid && !formGroup.value.basic.DocumentoLista" (click)="onSave()" title="Guardar"><i class="fa fa-save"></i> Guardar</button>
        <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
            <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
            Guardando
        </button>
    </form>
</nav>

<div class="container-fluid container-list">

    <app-documentacioncam-update [campaniaEspecifica]="campaniaEspecifica" [tiposDocumentacionCam]="tiposDocumentacionCam" [formGroup]="formGroup.get('basic')" (newDocumentation)="addNewDocumentation($event)" (markToDelete)="markAllToDelete($event)"></app-documentacioncam-update>

    <app-documentacioncam-list *ngIf="vm$ | async" [adjuntarDocumentacion]="formGroup.get('basic').value.AdjuntarDocumentacion" [campaniaEspecifica]="campaniaEspecifica" [documentos]="documentos" (delete)="onDelete($event)" (undoDelete)="onUndoDelete($event)"></app-documentacioncam-list>

</div>
